import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { VerifyOtpResponse } from 'src/app/models/verify-otp.response';
import { ApiService } from 'src/app/services/api.service';
import { SiteContentService } from 'src/app/services/site-content.service';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss'],
})
export class OtpComponent implements OnInit {

  @Input() otpKey: string;
  @Input() email: string;
  @Input() title: string;

  @ViewChild('otpForm') otpForm: FormGroup;

  @Output() next = new EventEmitter<VerifyOtpResponse>();
  @Output() back = new EventEmitter();

  message: string = 'Verifying your OTP...'
  loading: boolean = false;
  otp: string;
  submitted = false;
  error: string;
  errorKey: string;
  sentMessage: string;

  constructor(
    private api: ApiService,
    private siteContent: SiteContentService
  ) { }

  async ngOnInit() {
    this.sentMessage = (await this.siteContent.getSiteContent("FullQuote.SentSmsEmailOtp")).body;
  }

  async continue() {
    this.submitted = true;
    this.loading = true;
    try {
      const rsp = await this.verify();
      this.next.emit(rsp);
    } catch (err: any) {
      if (err.message != "Invalid OTP")
        this.errorKey = "FullQuote.Error";
      this.error = err.message;
    }
    finally {
      this.loading = false;
    }
  }

  async verify() {
    return await this.api.verifyOtp(this.email, this.otp, this.otpKey);
  }
}
